import {
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  grayColor,

  redCardHeader,
  orangeCardHeader,
  yellowCardHeader,
  greenCardHeader,
  blueCardHeader,
  purpleCardHeader,
  brownCardHeader,
} from "../cmsMainStyle"

const cardIconStyle = {
  cardIcon: {
    "&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$roseCardHeader,&$redCardHeader,&$orangeCardHeader,&$yellowCardHeader,&$greenCardHeader,&$blueCardHeader,&$purpleCardHeader,&$brownCardHeader" : {
      borderRadius: "3px",
      backgroundColor: grayColor[0],
      padding: "15px",
      marginTop: "-20px",
      marginRight: "15px",
      float: "left"
    }
  },

  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  roseCardHeader,
  redCardHeader,
  orangeCardHeader,
  yellowCardHeader,
  greenCardHeader,
  blueCardHeader,
  purpleCardHeader,
  brownCardHeader,
}

export default cardIconStyle
